/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Cancel_LabelInputs */

const en_team_sync_cancel_label = /** @type {(inputs: Team_Sync_Cancel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel sync`)
};

const fr_team_sync_cancel_label = /** @type {(inputs: Team_Sync_Cancel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler la synchronisation`)
};

const de_team_sync_cancel_label = /** @type {(inputs: Team_Sync_Cancel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronisierung abbrechen`)
};

const it_team_sync_cancel_label = /** @type {(inputs: Team_Sync_Cancel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulla sincronizzazione`)
};

const ru_team_sync_cancel_label = /** @type {(inputs: Team_Sync_Cancel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отменить синхронизацию`)
};

const es_team_sync_cancel_label = /** @type {(inputs: Team_Sync_Cancel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar sincronización`)
};

const zh_cn2_team_sync_cancel_label = /** @type {(inputs: Team_Sync_Cancel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消同步`)
};

const ja_team_sync_cancel_label = /** @type {(inputs: Team_Sync_Cancel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同期をキャンセル`)
};

const hi_team_sync_cancel_label = /** @type {(inputs: Team_Sync_Cancel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सिंक रद्द करें`)
};

const pt_pt2_team_sync_cancel_label = /** @type {(inputs: Team_Sync_Cancel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar sincronização`)
};

/**
* | output |
* | --- |
* | "Cancel sync" |
*
* @param {Team_Sync_Cancel_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_cancel_label = /** @type {((inputs?: Team_Sync_Cancel_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Cancel_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_sync_cancel_label(inputs)
	if (locale === "de") return de_team_sync_cancel_label(inputs)
	if (locale === "it") return it_team_sync_cancel_label(inputs)
	if (locale === "ru") return ru_team_sync_cancel_label(inputs)
	if (locale === "es") return es_team_sync_cancel_label(inputs)
	if (locale === "zh-CN") return zh_cn2_team_sync_cancel_label(inputs)
	if (locale === "ja") return ja_team_sync_cancel_label(inputs)
	if (locale === "hi") return hi_team_sync_cancel_label(inputs)
	if (locale === "pt-PT") return pt_pt2_team_sync_cancel_label(inputs)
	return en_team_sync_cancel_label(inputs)
});